import React, { Component } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import ModalVideo from 'react-modal-video';

class VideoFrame extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    this.openModal = this.openModal.bind(this);
  }
  openModal() {
    this.setState({ isOpen: true });
  }
  render() {
    return (
      <div className="noctil-videoframe">
        <div className="pt--60">
          <div className="row">
            <div className="col-lg-12 text-center">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                <h2>Here's How We Make It All Possible!</h2>
              </ScrollAnimation>
            </div>
            <div className="col-lg-12 text-center">
              <div className="">
                <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                  <div className="rn-section bg_color--1 line-separator">
                    <div>
                      <div className="row sercice-details-content align-items-center">
                        <div className="col-lg-12">
                          <div className="thumb position-relative">
                            <img
                              className="w-100"
                              src="/assets/images/video-frames/home-video-frame.svg"
                              alt="Here's How We Make It All Possible!"
                            />
                            <ModalVideo
                              channel="custom"
                              isOpen={this.state.isOpen}
                              url="/assets/video/noctil.mp4"
                              onClose={() => this.setState({ isOpen: false })}
                            />
                            <button
                              className="video-popup position-top-center"
                              onClick={this.openModal}
                            >
                              <span className="play-icon"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ScrollAnimation>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default VideoFrame;
